import * as React from "react";
import { times, isEmpty } from "lodash";
import { toastr } from "react-redux-toastr";
import Button from "reactstrap/lib/Button";
import queryString from 'query-string'
import { CasesService } from "src/share/services/cases";
import ClosedCasesTable from "./components/ClosedCasesTable";
import ClosedCasesRow from "./components/ClosedCasesRow";
import ClosedCasesSkeleton from "./components/ClosedCasesSkeleton";
import { IClosedCasesBulkProps, IClosedCasesToBulk } from "src/share/types/case/case";
import "./ClosedCasesBulk.css";

const ClosedCasesBulk = (props: IClosedCasesBulkProps)  => {
  const [closedCases, setClosedCases] = React.useState([]);
  const [updatedCases, setUpdatedCases] = React.useState<IClosedCasesToBulk>({});
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    const range = queryString.parse(props.location.search);
    if(range.from && range.to) {
      getClosedCases(+range.from, +range.to);
    }
  }, []);
  async function getClosedCases(from: number, to: number) {
    try {
      const { results } = await CasesService.getClosedByRange({ gte: from, lte: to });
      const newClosedCases = results.map(({ caseId, children, openDate, closeReason }) => (
        { caseId, children: children.map(child => ({ name: child.fullName, photo: child.images.portrait })), date: openDate, closeReason }
      ));
      setClosedCases(newClosedCases);
      setIsLoading(false);
    } catch(error) {
      toastr.error("Error", error.payload);
      setIsLoading(false);
    }
  }
  async function handleSubmit() {
    try {
      if(!isEmpty(updatedCases)) {
        await CasesService.bulkUpdateClosed(updatedCases);
        toastr.success("Success", "The case information was updated.");
      }
      props.history.push("/");
    } catch(error) {
      toastr.error("Error", error.payload);
    }
  }
  return (
    <div className="closed-cases-bulk__container">
      <div className="closed-cases-bulk__card white-background">
        <h1>Recently Closed Cases</h1>
        <ClosedCasesTable >
          {!isLoading  ? closedCases.map((closedCase: any) => 
            <ClosedCasesRow
              key={closedCase.caseId}
              closedCase={closedCase} 
              updatedCases={updatedCases} 
              onSetUpdatedCases={(caseId, closeReason) => setUpdatedCases({ ...updatedCases, [caseId]:{ closeReason }})} 
            />
          ) :
          times(5).map((e, i) => <ClosedCasesSkeleton key={i}/>)}
        </ClosedCasesTable>
        <Button className="btn btn-outline btn-green-fill float-right closed-cases-bulk__submit" onClick={handleSubmit} disabled={isLoading}>
          Submit
        </Button>
      </div>
    </div>
  );
}

export default React.memo(ClosedCasesBulk);
